export enum OfEtat {
  ANNULE = "ANNULE",
  EN_ATTENTE_PLANNIF = "EN_ATTENTE_PLANNIF",
  EN_ATTENTE_PROD = "EN_ATTENTE_PROD",
  EN_ATTENTE_BILAN_MATIERE = "EN_ATTENTE_BILAN_MATIERE",
  EN_PROD = "EN_PROD",
  EN_ATTENTE_REINTE_PDC = "EN_ATTENTE_REINTE_PDC",
  EN_ATTENTE_VALIDATION = "EN_ATTENTE_VALIDATION",
  VALIDE = "VALIDE",
}
